// extracted by mini-css-extract-plugin
export default {"task":"style_task__04Y1G","sortableTask":"style_sortableTask__vo0sQ","activityLog":"style_activityLog__92LBv"};